import FormView from './FormView.vue';
import FormHeader from './FormHeader.vue';
import moduleId from './moduleId';

class FormsRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/forms/:instance',
        name: 'forms',
        meta: {
          moduleType,
          baseRoute: true,
          moduleId,
          initiateSyncBeforeNav:true
        },
        components: { default: FormView, header: FormHeader },
      },

      {
        path: '/forms/:instance/:formId',
        props: true,
        name: 'forms-item',
        meta: {
          moduleType,
          baseRoute: false,
          moduleId,
        },

        components: { default: FormView, header: FormHeader },
      },
    ];
  };

}

const routeHandler = new FormsRouteHandler();
export default routeHandler;
